(function () {
    'use strict';

    var module = angular.module('uwAgenda.downloads');
    module.directive('popularDownloadItem', [PopularDownloadItemFn]);

    // directive for items in popular downloads section
    function PopularDownloadItemFn() {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/downloads/templates/popular-download-item.template.html',
            scope: {
                url: '@',
                imageSrc: '@',
                captionResource: '@',
                descriptionResource: '@'
            }
        };
        return directive;

        function link(scope, element, attrs) {
        } // link
    }
})();